import React, {useState} from "react";
import {Calendar, dateFnsLocalizer} from "react-big-calendar";
import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import getDay from "date-fns/getDay";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-datepicker/dist/react-datepicker.css";
import {MyEvents} from "../../data/CalendarData";


const CalendarF = () => {

    const locales = {
        "de": require("date-fns/locale/de")
    };


    const localizer = dateFnsLocalizer({
        format,
        parse,
        startOfWeek,
        getDay,
        locales,
    });


    
    const [allEvents] = useState(MyEvents);
    return (

        <>      
            <div className="heading" style={{padding:"60px 0", display:"flex", flexDirection:"column", justifyContent:"center", background:"#940000"}}></div>
            <div className= "settings" style={{textAlign: "center", display:"flex", flexDirection:"column", justifyContent:"center", background:"white", marginBottom:"-30px", paddingTop:"5%", paddingBottom:"5%"}}>
                <h1>Calendar</h1>
            </div>
            <Calendar localizer={localizer} events={allEvents} startAccessor= "start" endAccessor= "end" style={{height: 500, marginTop: "30px", background:"white", marginBottom:"25px", paddingBottom:"3%", marginLeft:"35px", marginRight: "35px"}}/>

        </>
    )

}

export default CalendarF;